/**
 * A contact list is Person.phones. A conversation's counterparty is read off
 * `direction` — inbound's from_number, outbound's to_number — rather than
 * off this org's own Twilio number, so grouping never has to know that
 * number at all.
 */

export function indexPeopleByPhone(personItems) {
  const byPhone = new Map();
  for (const item of personItems) {
    const f = item.fields || {};
    const phones = Array.isArray(f.phones) ? f.phones : [];
    for (const phone of phones) {
      if (!phone) continue;
      // First Person wins. Two Person records sharing a phone is a data
      // problem this surfaces by picking one, not by merging two identities.
      if (!byPhone.has(phone)) {
        byPhone.set(phone, { id: item.id, displayName: f.display_name || phone });
      }
    }
  }
  return byPhone;
}

export function buildConversations(messageItems, byPhone) {
  const byNumber = new Map();
  for (const item of messageItems) {
    const f = item.fields || {};
    if (!f.direction || !f.sent_at) continue;
    const counterparty = f.direction === "inbound" ? f.from_number : f.to_number;
    if (!counterparty) continue;
    if (!byNumber.has(counterparty)) byNumber.set(counterparty, []);
    byNumber.get(counterparty).push({
      id: item.id,
      direction: f.direction,
      body: f.body || "",
      sentAt: f.sent_at,
    });
  }

  const conversations = [];
  for (const [number, msgs] of byNumber) {
    msgs.sort((a, b) => new Date(a.sentAt) - new Date(b.sentAt));
    const last = msgs[msgs.length - 1];
    conversations.push({
      number,
      person: byPhone.get(number) || null,
      messages: msgs,
      lastMessage: last,
      // The brief's own definition: latest message inbound means awaiting reply.
      awaitingReply: last.direction === "inbound",
    });
  }
  conversations.sort((a, b) => new Date(b.lastMessage.sentAt) - new Date(a.lastMessage.sentAt));
  return conversations;
}
